/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HbsRemiseListItem } from './HbsRemiseListItem';
import {
    HbsRemiseListItemFromJSON,
    HbsRemiseListItemFromJSONTyped,
    HbsRemiseListItemToJSON,
    HbsRemiseListItemToJSONTyped,
} from './HbsRemiseListItem';

/**
 * Liste des remises HBS + contexte d'environnement. Si isProduction = false, le front affiche un bandeau garde-fou « ne jamais déposer ces fichiers sur le portail HBS de production » (les fichiers sont préfixés NE-PAS-UPLOADER-{ENV}).
 * 
 * @export
 * @interface GetHbsRemisesResponse
 */
export interface GetHbsRemisesResponse {
    /**
     * Nom de l'environnement back, ex. "Development" | "PreProd" | "Production"
     * @type {string}
     * @memberof GetHbsRemisesResponse
     */
    environment: string;
    /**
     * false = environnement de test, afficher le bandeau garde-fou
     * @type {boolean}
     * @memberof GetHbsRemisesResponse
     */
    isProduction: boolean;
    /**
     * Remises générées, triées de la plus récente à la plus ancienne
     * @type {Array<HbsRemiseListItem>}
     * @memberof GetHbsRemisesResponse
     */
    remises: Array<HbsRemiseListItem>;
}

/**
 * Check if a given object implements the GetHbsRemisesResponse interface.
 */
export function instanceOfGetHbsRemisesResponse(value: object): value is GetHbsRemisesResponse {
    if (!('environment' in value) || value['environment'] === undefined) return false;
    if (!('isProduction' in value) || value['isProduction'] === undefined) return false;
    if (!('remises' in value) || value['remises'] === undefined) return false;
    return true;
}

export function GetHbsRemisesResponseFromJSON(json: any): GetHbsRemisesResponse {
    return GetHbsRemisesResponseFromJSONTyped(json, false);
}

export function GetHbsRemisesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHbsRemisesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'environment': json['environment'],
        'isProduction': json['isProduction'],
        'remises': ((json['remises'] as Array<any>).map(HbsRemiseListItemFromJSON)),
    };
}

export function GetHbsRemisesResponseToJSON(json: any): GetHbsRemisesResponse {
    return GetHbsRemisesResponseToJSONTyped(json, false);
}

export function GetHbsRemisesResponseToJSONTyped(value?: GetHbsRemisesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'environment': value['environment'],
        'isProduction': value['isProduction'],
        'remises': ((value['remises'] as Array<any>).map(HbsRemiseListItemToJSON)),
    };
}

